var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 20H17.0832V19.1667H16.6666V20H15.4166V19.1667H14.9999V20H13.7499V19.1667H13.3333V20H12.0833V19.1667H11.6666V20H10.4166V19.1667H9.99995V20H8.74995V19.1667H8.33329V20H7.0833V19.1667H6.66663V20H5.41664V19.1667H4.99997V20H3.74998V19.1667H3.33332V20H2.08332V19.1667H1.66666V20H0V18.3333H0.833329V17.9167H0V16.6667H0.833329V16.25H0V15H0.833329V14.5833H0V13.3333H0.833329V12.9167H0V11.6667H0.833329V11.25H0V10H0.833329V9.58333H0V8.33333H0.833329V7.91667H0V6.66667H0.833329V6.25H0V5H0.833329V4.58333H0V3.33333H0.833329V2.91667H0V0L19.9999 20ZM4.16664 15.8333H9.94054L4.16664 10.0594V15.8333Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerLogo);
export default __webpack_public_path__ + "static/media/ruler_logo.71c64af852758bc7466622e2709ebf0c.svg";
export { ForwardRef as ReactComponent };